import React, { Component } from 'react';
import Loading from '../../Loading.js'
import ControlMessages from './ControlMessages.js';
import { getListMessages } from '../../../Api/ExtranetActions.js'

declare var globalSns;
declare var globalExtranet;

class ExtranetMessages extends Component {
    constructor(props) {
        super(props);

        this.state = {}

        this.reload = this.reload.bind(this);
    }

    componentWillMount() {
        this.loadData();
    }

    loadData() {
        getListMessages(globalSns.languageId, globalExtranet.showOpenOnly, (data) => {
            this.setState({
                listmessages: data
            });
        });


    }

    reload() {
        this.loadData();
    }

    render() {
        if (this.state.listmessages == null) {
            return (
                <Loading/>
            );
        }
        return (
            <div className="container-fluid">
                <div className="row">
                    <ControlMessages messages={this.state.listmessages} 
                        onNavigateToCandidates={(row) => this.props.onNavigate("extranetCandidatesFiche", row.candidateId, row.candidateFirstName + " " + row.candidateName)} 
                        onNavigateToProjects={(row) => this.props.onNavigate("extranetProjectsFiche", row.projectId, row.project)}
                        onReload={this.reload} />
                </div>
            </div>
        );
    }
}

export default ExtranetMessages;


// WEBPACK FOOTER //
// ./src/Components/Extranet/Pages/ExtranetMessages.js